import router from "@/router"
import axios from "axios"

export default ({
    namespaced: true,
    state: {
        token: {},
        errorMessages: []
    },
    mutations: {
        SET_TOKEN(state, data) {
            state.token = {
                auth: {
                    accessToken: data.token.access_token,
                    tokenType: data.token.token_type,
                    refreshToken: data.token.refresh_token,
                    expiresIn: data.token.expiry,
                }
            }
            localStorage.setItem('preferences', JSON.stringify(state.token))
            // console.log('preferences :', JSON.stringify(state.auth))
            // console.log('localStorage :', JSON.parse(localStorage.getItem('preferences')))
            router.replace({ name: 'home' })
        }
    },
    actions: {
        async getAccessToken({ commit, rootState, state }, data) {
            // console.log('code', data.code)
            // console.log('state', data.state)
            const url = `${rootState.baseUrl}/api/v1/signin`;
            const params = {
                code: data.code,
                state: data.state
            }
            await axios.post(url, params)
                .then((response) => {
                    // console.log('Response :', response.data)
                    commit('SET_TOKEN', response.data)
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    router.replace({ name: 'login' })
                })
        },
        async getRefreshToken({ commit, rootState, state }, refreshToken) {
            const url = `${rootState.baseUrl}/api/v1/refresh`;
            const params = {
                refresh_token: refreshToken
            }
            try {
                const response = await axios.post(url, params)
                const status = response.status
                if (status === 200) {
                    // console.log('New Token :', response.data)
                    commit('SET_TOKEN', response.data)
                }
            } catch (error) {
                console.log("ERROR = ", error.response.data)
                localStorage.removeItem('preferences')
                rootState.auth = {}
                console.log('Refresh Token Expired')
                router.replace({ name: 'login' })
                // if (error.response.status === 400) {
                //     console.log('Refresh Token Expired')
                //     router.replace({ name: 'login' })
                // } else if (error.response.status === 401) {
                //     console.log('Unauthorized')
                // }
            }
        },
        async logout() {
            try {
                localStorage.clear();
                console.log('localStorage cleared');
                router.replace({ name: 'login' });

            } catch (error) {
                console.error('Error clearing localStorage:', error);
            }
        }
    }
});